import { Filter } from './types';
import { escapeSearchSpecialCharacters } from './query-formatters';

export const AuthorsFilter = (authors: string): Filter => {
  const trimmedAuthors = authors.trim();
  return trimmedAuthors ? { 'authors.fullName': escapeSearchSpecialCharacters(trimmedAuthors) } : {};
};

export const SerieFilter = (serieId: string): Filter => ({ 'serie.id': serieId });

export const OriginalTitleFilter = (originalTitle: string): Filter => {
  const trimmedOriginalTitle = originalTitle.trim();
  return trimmedOriginalTitle ? { originalTitle: escapeSearchSpecialCharacters(trimmedOriginalTitle) } : {};
};

export const LanguageTextFilter = (languages: string): Filter => ({ 'languages.text': languages });

export const LanguageAudioFilter = (languages: string): Filter => ({ 'languages.audio': languages });

export const LanguageVideoFilter = (languages: string): Filter => ({ 'languages.video': languages });

export const AgeFilter = (min: number, max: number): Filter => ({
  ages: `age(${Number.isFinite(min) ? min : 0}, ${Number.isFinite(max) ? max : 99})`,
});

export const CategoryFilter = (categoryId: string): Filter => ({ categories: categoryId });

export const SubscriptionTypeFilter = (type: string | string[]): Filter => ({
  'accessRules.subscriptionType': type,
});

export const RealmFilter = (realm: string): Filter => ({ realm });

export const AvailabilityRealmsFilter = (realm: string): Filter => ({ availabilityRealms: realm });

export const RoleFilter = (role: string): Filter => ({
  'accessRules.roles': role,
});
